import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const isRastreamento = location.pathname === '/rastreamento';
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    // Em mobile, controla o overlay
    // Em desktop, controla o colapso da sidebar
    if (window.innerWidth <= 768) {
    setSidebarOpen(!sidebarOpen);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const closeSidebar = () => {
    // Fechar sidebar em dispositivos móveis quando clicar em um item do menu
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  };

  // Determinar a classe CSS baseada no estado da sidebar
  const sidebarClass = sidebarCollapsed ? 'sidebar-collapsed' : '';

  return (
    <div className={`layout ${sidebarClass}`}>
      <Sidebar
        isOpen={sidebarOpen}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebarCollapse}
        onClose={closeSidebar}
      />
      <div className="layout-main">
        <Header onMenuToggle={toggleSidebar} />
        <main className={`main-content${isRastreamento ? ' main-content--rastreamento' : ''}`}>
          {children}
        </main>
      </div>
      {/* Overlay para mobile */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar} />
      )}
    </div>
  );
};

export default Layout;
